import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import type { ReactNode } from 'react';

export function SlackIcon(props: SvgIconProps): ReactNode {
  return (
    <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M9 13a2 2 0 1 1-2-2h2v2zm1 0a2 2 0 0 1 4 0v5a2 2 0 0 1-4 0v-5z"
        fill="currentColor"
        opacity=".85"
      />
      <path
        d="M11 9a2 2 0 1 1 2 2h-2V9zm0-1a2 2 0 0 1-4 0V3a2 2 0 0 1 4 0v5z"
        fill="currentColor"
        opacity=".55"
      />
    </SvgIcon>
  );
}
